<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="toggleWantClose()">
                <div class="modal-container-create" @click.stop>
                    <div class="modal-header-create">
                        {{ titres[contenuMontre[indexContenuMontre]] }}
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="toggleWantClose()">mdi-close</v-icon>
                            <v-icon v-if="indexContenuMontre > 0" style="float: right; margin-right: 1vw; top: 0.3vh;"
                                @click="previousContent()">mdi-arrow-left</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-create">
                        <BodyDescription v-if="contenuMontre[indexContenuMontre] === 0"
                            :initDescr="donneesAudit[contenuMontre[indexContenuMontre]]" @disable="disable"
                            @enable="enable" @answer="getAnswer($event)"></BodyDescription>
                        <BodyRampants v-if="contenuMontre[indexContenuMontre] === 1"
                            :initRampants="donneesAudit[contenuMontre[indexContenuMontre]]" :calepinage="donneesAudit[5]" @disable="disable"
                            @enable="enable" @answer="getAnswerAndCalepinage($event)"></BodyRampants>
                        <BodyOnduleur v-if="contenuMontre[indexContenuMontre] === 2" :install_id="install_id"
                            :initOnduleurs="donneesAudit[contenuMontre[indexContenuMontre]]" :initHistorique="donneesAudit[4]" :initCalepinage="donneesAudit[5]" @disable="disable"
                            @enable="enable" @answer="getAnswerCaplepinageAndHistorique($event)"></BodyOnduleur>
                        <BodyModule v-if="contenuMontre[indexContenuMontre] === 3" :install_id="install_id"
                            :initModules="donneesAudit[contenuMontre[indexContenuMontre]]" :initCalepinage="donneesAudit[5]" @disable="disable"
                            @enable="enable" @answer="getAnswerAndCalepinage($event)"></BodyModule>
                        <BodyHistorique v-if="contenuMontre[indexContenuMontre] === 4"
                            :initHistorique="donneesAudit[contenuMontre[indexContenuMontre]]" :initCalepinage="donneesAudit[5]"
                            :onduleurs="donneesAudit[2]" @disable="disable" @enable="enable"
                            @answer="getAnswerAndCalepinage($event)"></BodyHistorique>
                        <BodyCalepinage v-if="contenuMontre[indexContenuMontre] === 5" :install_id="install_id"
                            :initCalepinage="donneesAudit[contenuMontre[indexContenuMontre]]"
                            :historiqueOnduleurs="donneesAudit[4]" :onduleurs="donneesAudit[2]"
                            :rampants="donneesAudit[1]" :modules="donneesAudit[3]" @disable="disable" @enable="enable"
                            @answer="getAnswer($event)"></BodyCalepinage>
                        <BodyDonnees v-if="contenuMontre[indexContenuMontre] === 6" :install_id="install_id"
                            :initDonnee="donneesAudit[contenuMontre[indexContenuMontre]]" @disable="disable"
                            @enable="enable" @answer="getAnswer($event)"></BodyDonnees>
                    </div>

                    <div class="modal-footer-create">
                        <v-btn v-if="indexContenuMontre === contenuMontre.length - 1" :disabled="suivantInactif"
                            style="float: right; background-color: #F49301; padding: 1vh; font-size: 1.8vh"
                            @click="createAudit()">
                            {{ $t('_valider_') }}
                        </v-btn>
                        <v-btn v-else :disabled="suivantInactif"
                            style="float: right; background-color: #F49301; padding: 1vh; font-size: 1.8vh"
                            @click="nextContent()">
                            {{ $t('_suivant_') }}
                        </v-btn>
                        <v-btn v-if="this.type === 'create'"
                            style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw ; font-size: 1.8vh;"
                            @click="toggleSave()">
                            {{ $t('_enregistrer_brouillon_') }}
                        </v-btn>
                    </div>
                    <PopUpEnregistrer v-if="this.modalEnregistrer" @close="toggleSave()" @save="saveDraft($event)">
                    </PopUpEnregistrer>
                    <PopUpValider v-if="this.modalFermer" @close="toggleWantClose()" @confirm="$emit('close')"
                        @save="toggleSave()"></PopUpValider>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import BodyRampants from '@/components/Creation/BodyRampants.vue'
import BodyDescription from '@/components/Creation/BodyDescription.vue'
import BodyOnduleur from './BodyOnduleur.vue'
import BodyModule from './BodyModule.vue'
import BodyHistorique from './BodyHistorique.vue'
import BodyCalepinage from './BodyCalepinage.vue'
import PopUpEnregistrer from './PopUpEnregistrer.vue'
import PopUpValider from './PopUpValider.vue'
import BodyDonnees from './BodyDonnees.vue'
import backend from '@/api/backend'
import api from '@/api/api'


export default {
    components: {
        BodyRampants,
        BodyDescription,
        BodyOnduleur,
        BodyModule,
        BodyHistorique,
        BodyCalepinage,
        PopUpEnregistrer,
        PopUpValider,
        BodyDonnees
    },

    props: {
        type: {
            required: true,
        },
        data: {
            required: false,
        },
        installAModif: {
            required: false,
        }
    },

    async mounted() {
        //definir quelle page du formulaire sera a afficher en fonction de où la popup a été apelé
        switch (this.type) {
            case "create":
                this.contenuMontre = [0, 1, 2, 3, 4, 5, 6];
                break;
            case "modifier":
                this.contenuMontre = [0, 1, 2, 3, 4, 5, 6];
                this.modification = true;
                break;
            case "onduleur":
                this.contenuMontre = [2, 4, 5];
                this.modification = true;
                break;
            case "rampant":
                this.contenuMontre = [1, 5];
                this.modification = true;
                break;
            case "calepinage":
                this.contenuMontre = [5];
                this.modification = true;
                break;
        }
        this.utilisateur = (await api.currentUser()).data.id
        this.getData()
    },

    data() {
        return {
            modification: false,
            suivantInactif: true,
            contenuMontre: [],
            indexContenuMontre: 0,
            titres: [this.$t("_description_du_site_"), this.$t("_inventaire_des_rampants_"), this.$t("_inventaire_des_onduleurs_"), this.$t("_inventaire_des_module_"), this.$t("_historique_des_onduleurs_"), this.$t("_calepinage_"), this.$t("_donnes_temporelles_")],
            donneesAudit: [],
            files: {},
            modalEnregistrer: false,
            modalFermer: false,
            install_id: null,
            utilisateur: null,
        }
    },
    methods: {
        nextContent() {
            this.indexContenuMontre += 1
            this.suivantInactif = true
        },
        previousContent() {
            this.indexContenuMontre--
        },

        disable() {
            this.suivantInactif = true
        },

        enable() {
            this.suivantInactif = false
        },

        toggleSave() {
            if ((this.data === null || this.data === undefined)&& !this.modification) {
                this.modalFermer = false
                this.modalEnregistrer = !this.modalEnregistrer
            }
            else
                this.saveDraft('')
        },

        async saveDraft(nom) {
            if(this.modification){
                this.createAudit()
            }
            else{
            if (this.data !== null) {
                const id = this.data.id
                const nom = this.data.name
                await backend.put_draft_to_id(this.utilisateur, id, nom, this.install_id, this.donneesAudit)
            }
            else {
                if (nom === "") {
                    const maintenant = new Date()
                    const dateHeure = maintenant.getFullYear() + '-' + (maintenant.getMonth() + 1) + '-' + maintenant.getDate() + ' à ' + maintenant.getHours() + ":" + maintenant.getMinutes() + ":" + maintenant.getSeconds()

                    nom = 'Brouillon du ' + dateHeure
                }

                await backend.post_new_draft(this.utilisateur, nom, this.install_id, this.donneesAudit)

                
            }
            for (var type in this.files.anciennesDonnees) {
                    for (var fichier in type) {
                        if (this.files.anciennesDonnees[type][fichier] !== undefined)
                            if (this.files.anciennesDonnees[type][fichier].created_at === "")
                                await backend.delete_production_data_from_id(this.files.anciennesDonnees[type][fichier].id, this.install_id)
                    }
                }

                for (var fileType in this.files.nouvelleDonnees) {
                    let intType = -1
                    switch (fileType) {
                        case "prod":
                            intType = 0
                            break
                        case "meteoSatellites":
                            intType = 1
                            break
                        case "meteoInSitu":
                            intType = 2
                            break
                        case "compteur":
                            intType = 3
                            break
                    }
                    for (fichier in this.files.nouvelleDonnees[fileType].value) {
                        await backend.post_new_production_data(this.install_id, this.files.nouvelleDonnees[fileType].value[fichier], intType)
                    }
                }
        }
            this.$emit('close')
        },

        toggleWantClose() {
                this.modalFermer = !this.modalFermer
        },

        getAnswer(reponse) {
            if (this.contenuMontre[this.indexContenuMontre] === 6)
                this.files = reponse
            else
                this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] = reponse
        },

        getAnswerAndCalepinage(reponse) {
            this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] = reponse.reponse
            if (reponse.calepinage!== undefined)
                this.donneesAudit[5]=reponse.calepinage
        },

        getAnswerCaplepinageAndHistorique(reponse) {
            this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] = reponse.reponse
            if (reponse.calepinage!== undefined)
                this.donneesAudit[5]=reponse.calepinage
            if (reponse.historique!== undefined)
                this.donneesAudit[4]=reponse.historique
        },

        async createAudit() {
            if (this.modification && this.type !== "modifier") {
                for (let frag in this.contenuMontre) {
                    await backend.put_install_form_frag(this.install_id, this.contenuMontre[frag], this.donneesAudit)
                }
            }
            else {
                if (this.data !== null && this.data !== undefined) {
                    await backend.delete_draft_from_id(this.utilisateur, this.data.id)
                }
                await backend.put_install_form(this.install_id, this.donneesAudit)

                for (var type in this.files.anciennesDonnees) {
                    for (var fichier in type) {
                        if (this.files.anciennesDonnees[type][fichier] !== undefined)
                            if (this.files.anciennesDonnees[type][fichier].created_at === "")
                                await backend.delete_production_data_from_id(this.files.anciennesDonnees[type][fichier].id, this.install_id)
                    }
                }

                for (var fileType in this.files.nouvelleDonnees) {
                    let intType = -1
                    switch (fileType) {
                        case "prod":
                            intType = 0
                            break
                        case "meteoSatellites":
                            intType = 1
                            break
                        case "meteoInSitu":
                            intType = 2
                            break
                        case "compteur":
                            intType = 3
                            break
                    }
                    for (fichier in this.files.nouvelleDonnees[fileType].value) {
                        await backend.post_new_production_data(this.install_id, this.files.nouvelleDonnees[fileType].value[fichier], intType)
                    }
                }
            }
            this.$emit("close")
        },

        async getData() {
            if (this.modification) {
                this.install_id = this.installAModif
                try {
                    const reponse = (await backend.get_install_form(this.installAModif)).data
                    this.donneesAudit[0] = reponse.description
                    this.donneesAudit[1] = reponse.rampants_inventory
                    this.donneesAudit[2] = reponse.inverters_inventory
                    this.donneesAudit[3] = reponse.modules_inventory
                    this.donneesAudit[4] = reponse.history
                    this.donneesAudit[5] = reponse.layouts
                }
                catch{
                    this.donneesAudit[0] = {}
                    this.donneesAudit[1] = []
                    this.donneesAudit[2] = []
                    this.donneesAudit[3] = []
                    this.donneesAudit[4] = []
                    this.donneesAudit[5] = []
                }
                this.$forceUpdate()
            }
            else {
                if (this.data != null) {
                    this.donneesAudit = this.data.json_data
                    console.log("reponse: ",  this.donneesAudit)
                    this.install_id = this.data.install_id
                }
                else {
                    this.install_id = (await backend.claim_new_install_id()).data.install_id
                }
            }

        }

    },

    watch: {
        data: {
            handler() {
                this.getData()
            }, deep: true
        },
        installAModif: {
            handler() {
                this.getData()
            }, deep: true
        }
    }
}

</script>

<style scoped>
.modal-container-create {
    width: 90vw;
    height: 80vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    /* display: grid; */
    flex-direction: column;
}

.modal-header-create {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-create {
    overflow-y: auto;
    overflow-x: hidden;
    height: 88%;
}

.modal-footer-create {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    bottom: 0;
    right: 0;
}
</style>